import React, { useContext, useLayoutEffect } from 'react';
import { ConfigProvider, message, App } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';


export const useLowBrowserMessage = ()=>{
  const { locale, theme } = useContext(ConfigProvider.ConfigContext);

  useLayoutEffect(() => {
    ConfigProvider.config({
      holderRender: (children) => (
        <StyleProvider hashPriority="high">
          <ConfigProvider prefixCls="ant"   locale={locale} theme={{
            components:{
              Message:{
                contentBg:'rgba(64, 64, 64, .8)'
              }
            }
          }}>
            <App message={{ maxCount: 10 }} notification={{ maxCount: 10 }}>
              {children}
            </App>
          </ConfigProvider>
        </StyleProvider>
      ),
    });
  }, [locale, theme]);
}

